import {
  useComposerMode,
  useIsDraftMode,
} from '~publish/components/Composer/store/appSlice/hooks'

import type { ComposerSaveMode } from '../../stores/types'

export const useComposerSaveMode = (): ComposerSaveMode => {
  const draftMode = useIsDraftMode()
  const composerMode = useComposerMode()

  if (draftMode) {
    return 'edit-draft'
  }

  if (composerMode === 'edit') {
    return 'edit-post'
  }

  return 'new-post'
}
